import React from 'react'
import T from 'prop-types'
import Input from 'components/Input'
import Joi from 'joi'

import Step from '../../components/Step'

export const validator = (values, user_id) => Joi.object({
  phone: Joi.string().min(8).required(),
}).unknown(true)

export default function Additional({ changeStep, values, onChange }) {
  const handleChange = (key) => ({ target: { value } }) => {
    onChange(key, value)
  }

  return (
    <Step
      title="Hva er ditt mobilnummer?"
      onSubmit={changeStep}
      submit="Gå videre"
      submitDisabled={!!validator(values).validate(values)?.error}
      info="Vi vil sende deg en SMS med informasjon om din påmelding. Ditt nummer vil ikke bli brukt til andre formål."
      footerSpacing
    >
      <Input
        short
        label="Telefonnummer"
        type="tel"
        tooltip="Norske telefonnummer kan legges inn uten landkode. Ved utenlandsk telefonnummer må man legge til landets retningsnummer først. Svenske nummer starter for eksempel med +46."
        value={values.phone || ''}
        onChange={handleChange('phone')}
      />
    </Step>
  )
}

Additional.propTypes = {
  changeStep: T.func.isRequired,
  values: T.object.isRequired,
  onChange: T.func.isRequired,
}
